import { Injectable } from '@angular/core';

export interface SupportContext {
  category?: string;
  origin?:   string;
  tags?:     string[];
  meta?:     Record<string, any>;
}

@Injectable({ providedIn: 'root' })
export class SupportContextService {
  private context: SupportContext = {};

  setContext(ctx: SupportContext)  { this.context = ctx; }
  clearContext()                    { this.context = {}; }
  getContext(): SupportContext      { return this.context; }
}
